import React from 'react'
import s from './PanelBase.module.scss'
import ReadOnlyOperatorsList from './ReadOnlyOperatorsList'
import ReadOnlyDriversList from './ReadOnlyDriversList'
import ReadOnlyBranchesList from './ReadOnlyBranchesList'
import MiniMap from 'pages/ReportCard/MiniMap'

const ChppsPanel = ({
  chppsFilter,
  setChppsFilter,
  filteredChpps,
  chppsPagination,
  loadChppsPage,
  expandedChpp,
  setExpandedChpp,
  expandedOperatorsChpp,
  setExpandedOperatorsChpp,
  expandedDriversChpp,
  setExpandedDriversChpp,
  expandedBranchesChpp,
  setExpandedBranchesChpp,
  loadOperatorsByChppPage,
  loadDriversByChppPage,
  loadBranchesByChppPage,
  operatorsByChpp,
  driversByChpp,
  branchesByChpp,
  operatorsPaginationByChpp,
  driversPaginationByChpp,
  branchesPaginationByChpp,
  operatorsFilterByChpp,
  driversFilterByChpp,
  branchesFilterByChpp,
  setOperatorsFilterByChpp,
  setDriversFilterByChpp,
  setBranchesFilterByChpp,

  expandedDriverByChpp,
  toggleDriver,
  chpps
}) => {
  return (
    <div className={s.panel}>
      <div className={s.header}>
        <h2 className={s.title}>ТЭЦ</h2>
        {chppsPagination?.count > 0 && (
          <span className={s.totalBadge}>Всего: {chppsPagination.count}</span>
        )}
      </div>

      <div className={s.searchRow}>
        <input className={s.searchInput} placeholder="Поиск по ТЭЦ..." value={chppsFilter} onChange={(e) => setChppsFilter(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') loadChppsPage(1, chppsFilter) }} />
      </div>

      {filteredChpps && filteredChpps.length ? (
        <div className={s.tableWrap}>
          <div className={s.tableScroll}>
          <table className={s.table}>
            <thead>
              <tr>
                <th>№</th>
                <th>Название</th>
                <th>Телефон</th>
                <th>Местоположение</th>
                <th>Действия</th>
              </tr>
            </thead>
            <tbody>
              {filteredChpps.map((chpp, index) => (
                <React.Fragment key={chpp.id}>
                  <tr>
                    <td className={s.numCell}>{index + 1}</td>
                    <td className={s.nameCell} onClick={() => { const newVal = (expandedChpp === chpp.id ? null : chpp.id); setExpandedChpp(newVal); if (newVal) loadOperatorsByChppPage(chpp.id, 1); }}>{chpp.name}</td>
                    <td>{chpp.phone || '—'}</td>
                    <td>
                      {chpp.geo ? (
                        <div style={{ display: 'flex', gap: '6px', flexDirection: 'column' }}>
                          <div style={{ display: 'flex', gap: '6px' }}>
                            <button onClick={() => window.open(`https://www.google.com/maps?q=${chpp.geo}`, '_blank')} className={s.geoBtn}>🗺️ Карты</button>
                            <button onClick={() => { const el = document.getElementById(`chpp-map-${chpp.id}`); if (el) el.style.display = el.style.display === 'none' ? 'block' : 'none'; }} className={s.mapToggleBtn}>📌</button>
                          </div>
                          <div id={`chpp-map-${chpp.id}`} style={{ width: 200, height: 150, display: 'none' }}><MiniMap geo={chpp.geo} /></div>
                        </div>
                      ) : '—'}
                    </td>
                    <td>
                      <button className={`${s.actionBtn}${expandedBranchesChpp === chpp.id ? ' ' + s.active : ''}`} onClick={() => { const v = expandedBranchesChpp === chpp.id ? null : chpp.id; setExpandedBranchesChpp(v); if (v) loadBranchesByChppPage(chpp.id, 1); setExpandedChpp(chpp.id); }}>Филиалы</button>
                      <button className={`${s.actionBtn}${expandedOperatorsChpp === chpp.id ? ' ' + s.active : ''}`} onClick={() => { const v = expandedOperatorsChpp === chpp.id ? null : chpp.id; setExpandedOperatorsChpp(v); if (v) loadOperatorsByChppPage(chpp.id, 1); setExpandedChpp(chpp.id); }}>Операторы</button>
                      <button className={`${s.actionBtn}${expandedDriversChpp === chpp.id ? ' ' + s.active : ''}`} onClick={() => { const v = expandedDriversChpp === chpp.id ? null : chpp.id; setExpandedDriversChpp(v); if (v) loadDriversByChppPage(chpp.id, 1); setExpandedChpp(chpp.id); }}>Водители</button>
                    </td>
                  </tr>
                  {expandedChpp === chpp.id && (
                    <tr className={s.subRow}>
                      <td colSpan={5}>
                        <div className={s.subContent}>
                          {expandedOperatorsChpp === chpp.id && (
                            <ReadOnlyOperatorsList
                              base={chpp}
                              operators={operatorsByChpp[chpp.id]}
                              operatorsFilter={operatorsFilterByChpp[chpp.id]}
                              setOperatorsFilter={(v) => setOperatorsFilterByChpp(prev => ({ ...prev, [chpp.id]: v }))}
                              loadOperatorsPage={loadOperatorsByChppPage}
                              operatorsPagination={operatorsPaginationByChpp[chpp.id]}
                              title="Операторы этой ТЭЦ"
                            />
                          )}

                          {expandedDriversChpp === chpp.id && (
                            <ReadOnlyDriversList
                              base={chpp}
                              drivers={driversByChpp[chpp.id]}
                              driversFilter={driversFilterByChpp[chpp.id]}
                              setDriversFilter={(v) => setDriversFilterByChpp(prev => ({ ...prev, [chpp.id]: v }))}
                              loadDriversPage={loadDriversByChppPage}
                              driversPagination={driversPaginationByChpp[chpp.id]}
                              expandedDriver={expandedDriverByChpp}
                              toggleDriver={toggleDriver}
                              title="Водители этой ТЭЦ"
                            />
                          )}

                          {expandedBranchesChpp === chpp.id && (
                            <ReadOnlyBranchesList
                              base={chpp}
                              baseType="ТЭЦ"
                              branches={branchesByChpp[chpp.id]}
                              branchesFilter={branchesFilterByChpp[chpp.id]}
                              setBranchesFilter={(v) => setBranchesFilterByChpp(prev => ({ ...prev, [chpp.id]: v }))}
                              loadBranchesPage={loadBranchesByChppPage}
                              branchesPagination={branchesPaginationByChpp[chpp.id]}
                            />
                          )}
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
          </div>
        </div>
      ) : (
        <div className={s.empty}>Список пуст</div>
      )}

      {!chppsFilter && chppsPagination?.count > 0 && (
        <div className={s.pagination}>
          <button className={s.pageBtn} disabled={!chppsPagination.previous} onClick={() => loadChppsPage((chppsPagination.page || 1) - 1)}>Пред.</button>
          <span>Стр. {chppsPagination.page || 1} из {Math.ceil(chppsPagination.count / 25)}</span>
          <button className={s.pageBtn} disabled={!chppsPagination.next} onClick={() => loadChppsPage((chppsPagination.page || 1) + 1)}>След.</button>
        </div>
      )}
    </div>
  )
}

export default ChppsPanel
